import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';

import styles from './styles.module.scss';

const FlexGrid = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={classNames(styles.FlexGrid, className)} {...rest} />
);

export default FlexGrid;
